import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const AuthenticationForLogin = () => {
    const isLoggedIn = window.localStorage.getItem('isLoggedIn');
  
    return isLoggedIn === 'true' ? <Outlet /> : <Navigate to="/" />;
};

export default AuthenticationForLogin;